module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kd-La.f3d26282.png";